"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../data/constants");
var constantsClasses_1 = require("../../data/constantsClasses");
var Storytelling = /** @class */ (function () {
    function Storytelling() {
        var _this = this;
        var _a;
        this.ticking = false; // Prevent multiple calls to scroll event
        this.storytellingContainer = document.querySelector("[".concat(constants_1.DATA_STORYTELLING_CONTAINER, "]"));
        this.storytellingSection = (_a = this.storytellingContainer) === null || _a === void 0 ? void 0 : _a.closest("[".concat(constants_1.DATA_STORYTELLING_SECTION, "]"));
        if (!this.storytellingContainer || !this.storytellingSection) {
            return;
        }
        this.updateMeasurements();
        window.addEventListener('resize', function () {
            _this.updateMeasurements();
        });
        window.addEventListener('scroll', function () {
            if (!_this.ticking) {
                requestAnimationFrame(function () {
                    _this.handleScroll();
                    _this.ticking = false;
                });
                _this.ticking = true;
            }
        });
    }
    Storytelling.prototype.updateMeasurements = function () {
        this.sectionOffsetTop = this.getElementOffsetTop(this.storytellingSection);
        this.containerScrollWidth = this.storytellingContainer.scrollWidth;
        this.setSectionHeight();
    };
    Storytelling.prototype.setSectionHeight = function () {
        this.sectionHeight = this.containerScrollWidth - window.innerWidth + window.innerHeight;
        this.storytellingSection.style.height = "".concat(this.sectionHeight, "px");
    };
    Storytelling.prototype.getElementOffsetTop = function (element) {
        var offsetTop = 0;
        while (element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }
        return offsetTop;
    };
    Storytelling.prototype.handleScroll = function () {
        if (!this.storytellingContainer)
            return;
        var scrollY = window.scrollY;
        var horizontalStart = this.sectionOffsetTop;
        var horizontalEnd = horizontalStart + this.sectionHeight;
        if (scrollY >= horizontalStart && scrollY < horizontalEnd - window.innerHeight) {
            this.storytellingContainer.classList.add(constantsClasses_1.CLASS_FIXED);
            this.storytellingContainer.classList.remove(constantsClasses_1.CLASS_END);
            var horizontalScroll = scrollY - horizontalStart;
            this.storytellingContainer.style.transform = "translateX(-".concat(horizontalScroll, "px)");
        }
        else if (scrollY >= horizontalEnd - window.innerHeight) {
            this.storytellingContainer.classList.remove(constantsClasses_1.CLASS_FIXED);
            this.storytellingContainer.classList.add(constantsClasses_1.CLASS_END);
            this.storytellingContainer.style.transform = "translateX(-".concat(this.containerScrollWidth - window.innerWidth, "px)");
        }
        else {
            this.storytellingContainer.classList.remove(constantsClasses_1.CLASS_END);
            this.storytellingContainer.classList.remove(constantsClasses_1.CLASS_FIXED);
            this.storytellingContainer.style.transform = '';
        }
    };
    return Storytelling;
}());
exports.default = Storytelling;
